import {DataGrid} from "../../components/DataGrid";
import {ShiftActivity} from "../../api/shift.slice.ts";

type ActivityListProps = {
    data: ShiftActivity[],
    // onSelect: (row: any) => void
}

const ToMinute = (duration: number): number  => {
    return Math.round( duration / 60 )
}

export const ActivityList = ({data}: ActivityListProps) => {

    const columns = [
        {key: "firstName", label: "FirstName" },
        {key: "lastName", label: "LastName"},
        {key: "rioId", label: "RioId"},
        {key: "type", label: "Type"},
        {key: "date", label: "Date"},
        {key: "startTime", label: "StartTime"},
        {key: "duration", label: "duration", convert: ToMinute},
        {key: "latitude", label: "Latitude"},
        {key: "longitude", label: "Longitude"},

    ]


    return <DataGrid data={data || []} columns={columns}/>

}